'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ./~/rp-react-svg-icon/~/react/react.js
// module id = 1495
// module chunks = 1